var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5L11.6464 5.14645L12 4.79289L12.3536 5.14645L12 5.5ZM12.5 14.5C12.5 14.7761 12.2761 15 12 15C11.7239 15 11.5 14.7761 11.5 14.5L12.5 14.5ZM6.64645 10.1464L11.6464 5.14645L12.3536 5.85355L7.35355 10.8536L6.64645 10.1464ZM12.3536 5.14645L17.3536 10.1464L16.6464 10.8536L11.6464 5.85355L12.3536 5.14645ZM12.5 5.5L12.5 14.5L11.5 14.5L11.5 5.5L12.5 5.5Z",
    fill: "#242833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5L5 17.5C5 18.6046 5.89543 19.5 7 19.5L17 19.5C18.1046 19.5 19 18.6046 19 17.5V16.5",
    stroke: "#242833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7630965b230e16da14887a94e065d7b7.svg";
export { ForwardRef as ReactComponent };